// type ListItem = {
// 	institution: string,
// 	title: string,
// 	date: string,
// 	collection: string,
// 	imageUrl: string,
// }

const listItemColumns = [
  {
    accessorKey: 'id'
  },
  {
    accessorKey: 'maker'
  },
  {
    accessorKey: 'title'
  },
  {
    accessorKey: 'date'
  },
  {
    accessorKey: 'collection'
  },
  {
    accessorKey: 'imageUrl'
  },
  {
    accessorKey: 'imageDownload'
  },
  {
    accessorKey: 'filename_slug'
  },
  {
    accessorKey: 'type'
  },
  {
    accessorKey: 'cr_data'
  },
  {
    accessorKey: 'credit_line'
  },
  {
    accessorKey: 'date_start'
  },
  {
    accessorKey: 'date_end'
  },
  {
    accessorKey: 'materials'
  },
  {
    accessorKey: 'dimensions'
  },
  {
    accessorKey: 'description'
  }
]

export default listItemColumns